import { SxProps } from '@mui/material';

export const contentContainerSx: SxProps = {
  flexGrow: 1,
  paddingTop: '64px',
  paddingLeft: '60px',
  paddingBottom: '122px',
  overflow: 'hidden'
};

export const gradientContainerSx: SxProps = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  height: 600,
  width: '100vw',
  zIndex: -1,
  background: 'linear-gradient(175.9deg, #F3F4FF 3.5%, #FFFFFF 28%)'
};
